import { z } from 'zod';
import { DashboardType } from '~/enums/_types';
import { zLuxonDateTime } from '~/plugins/zod/utils';
import { CurrencyCodeSchema } from '../_types';

export const DashboardChartItemInfoSchema = z.object({
    Month: zLuxonDateTime({ format: 'M-yyyy' }),
    Value: z.number(),
});

export const DashboardChartDataSetInfoSchema = z.object({
    Year: z.number(),
    Data: DashboardChartItemInfoSchema.array(),
});

export const DashboardChartDataSetInfoArraySchema = DashboardChartDataSetInfoSchema.array();

export const DashboardSummaryInfoSchema = z.object({
    CurrentCount: z.number(),
    PreviousCount: z.number(),
    CurrentPrice: z.number(),
    PreviousPrice: z.number(),
});

export const DashboardInfoSchema = z.object({
    Type: z.nativeEnum(DashboardType),
    Summary: DashboardSummaryInfoSchema,
    Unit: CurrencyCodeSchema.nullable(),
    Chart: DashboardChartDataSetInfoArraySchema,
});

export const DashboardInfoArraySchema = DashboardInfoSchema.array();

export const DashboardCurrencyInfoSchema = z.object({
    Currency: CurrencyCodeSchema,
    Data: DashboardInfoArraySchema,
});

export const FetchDashboardResponseSchema = DashboardCurrencyInfoSchema.array();

export type DashboardInfo = z.infer<typeof DashboardInfoSchema>;
export type DashboardInfoArray = z.infer<typeof DashboardInfoArraySchema>;
export type DashboardSummaryInfo = z.infer<typeof DashboardSummaryInfoSchema>;
export type DashboardChartItemInfo = z.infer<typeof DashboardChartItemInfoSchema>;
export type DashboardChartDataSetInfo = z.infer<typeof DashboardChartDataSetInfoSchema>;
export type DashboardChartDataSetInfoArray = z.infer<typeof DashboardChartDataSetInfoArraySchema>;
export type DashboardCurrencyInfo = z.infer<typeof DashboardCurrencyInfoSchema>;
export type FetchDashboardResponse = z.infer<typeof FetchDashboardResponseSchema>;
